export default __webpack_public_path__ + "static/media/rawsteel.852266b9.png";